module.exports = __webpack_public_path__ + "img/affiliate.d054249e.svg";